module.exports = __webpack_public_path__ + "static/media/B2.a5e2eba0.jpg";